<template>
  <div>
    <v-progress-circular
        indeterminate
        color="primary"
        v-if="savingInProgress"
    ></v-progress-circular>
    <v-form v-show="showAddForm" autocomplete="nope">
      <v-img v-if="tmpCar.link" :src="tmpCar.image" width="150px" />
      <v-text-field
          name="levamvin"
          autocomplete="nope"
          outlined
          v-if="tmpCar.link"
          v-model="tmpCar.name"
          :label="$t('common.title')"
      ></v-text-field>
      <v-text-field
          outlined
          v-if="tmpCar.link && isMileageVisible"
          v-model="tmpCar.mileage"
          :label="$t('common.mileage')"
      ></v-text-field>
      <v-text-field
          autocomplete="nope"
          outlined
          :value="tmpCar.vin"
          v-model="tmpCar.vin"
          :loading="searchByVinInProcessing"
          :disabled="searchByVinInProcessing"
          :label="$t('common.vin_frame')"
          :append-icon="'fa-search'"
          @click:clear="
          chooseByVin = false;
          vin = null;
        "
          clearable
          @click:append="vinFind"
      ></v-text-field>
      <v-text-field
          outlined
          v-model="tmpCar.car_number"
          :label="$t('common.car_number')"
      ></v-text-field>
      <v-autocomplete
          :id="'brands-levam' + Math.random()"
          outlined
          v-if="!chooseByVin"
          :loading="searchByVinInProcessing"
          :disabled="searchByVinInProcessing || !!tmpCar.link"
          :items="catalogsWithGroups"
          :label="$t('common.brand')"
          autocomplete="false"
          item-text="name"
          return-object
          :value="tmpCar.catalog_code"
          @input="
          (el) => {
            if (typeof el == 'object') {
              tmpCar.catalog_code = el;
            } else {
              tmpCar.catalog_code = null;
              return false;
            }
          }
        "
      >
        <template v-slot:item="data">
          <template v-if="typeof data.item !== 'object'" @click.stop="">
            <span
                class="pl-2 text-caption disabled"
                v-text="data.item"
                @click.stop=""
            ></span>
          </template>
          <template v-else>
            <v-list-item-content>
              <v-list-item-title>{{
                  data.item.name.toUpperCase()
                }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </template>
      </v-autocomplete>

      <v-autocomplete
          name="levammodel"
          outlined
          v-if="!chooseByVin && tmpCar.catalog_code"
          autocomplete="false"
          :loading="searchByVinInProcessing"
          :disabled="searchByVinInProcessing || !!tmpCar.link"
          :items="familiesList"
          item-text="name"
          return-object
          :label="$t('common.model')"
          v-model="selectedModelFamily"
      ></v-autocomplete>
      <template
          v-for="param in gettedParams"
          v-if="tmpCar.model && !chooseByVin && !tmpCar.link"
      >
        <div class="widget_oem_vehicle_one_param_wrap">

          <v-btn
              v-if="param.selected && !param.values"
              tile
              outlined
              @click="removeParamValue(param)"
              class="mx-0 my-3 px-3"
          >
            <v-icon left>fa-times</v-icon>
            {{ param.title }}: {{ param.caption }}

          </v-btn>
          <v-select
              outlined
              v-if="!param.selected"
              :label="param.title"
              :items="param.values"
              item-text="title"
              return-object
              @change="setParamValue"
              @click:clear="removeParamValue(param)"
              class="pointer"
              clearable
          ></v-select>
        </div>
      </template>
      <v-progress-circular
          indeterminate
          color="primary"
          v-if="modificationsIsLoading"
      ></v-progress-circular>
      <div v-if="selectedModificationProps" class="pb-3">
        <strong v-for="(value, key) in selectedModificationProps.item">
          <template v-if="key != 'link' && key.toUpperCase() != 'ADDITIONAL'">
            {{ key }}: {{ value }};
          </template>
        </strong>
        <v-btn
            icon
            color="warning"
            @click="clearForm"
        >
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-btn
            class="ma-2 ml-0"
            elevation="0"
            color="success"
            @click="selectCar"
        >
          {{ $t("common.select") }}
        </v-btn>
      </div>
      <v-btn
          class="ma-2 ml-0"
          elevation="0"
          color="warning"
          v-if="errorToAPIAccess"
          @click="isVisiblecarSelectorManual=!isVisiblecarSelectorManual"
      >
        {{ $t("car.add_manual") }}
      </v-btn>
        <car-selector-manual-window
            :show="isVisiblecarSelectorManual"
            @hide="isVisiblecarSelectorManual=!isVisiblecarSelectorManual"
            @choose="selectCarManual"
        />
    </v-form>
    <v-data-table
        v-if="
        modifications.length > 0 &&
        !modificationsIsLoading &&
        (showAddForm) &&
        !tmpCar.link &&
        (selectedModelFamily.family || chooseByVin)
      "
        :headers="modificationsTableHeader"
        :items="modifications"
        class="elevation-0 mb-3"
        :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:item="props">
        <tr>
          <td class="text-xs-center">
            <v-btn
                class="ma-2 ml-0"
                elevation="0"
                color="success"
                @click="selectModification(props.item.link, props)"
            >
              {{ $t("common.select") }}
            </v-btn>
          </td>
          <template v-for="(item, i) in props.item">
            <template v-if="props.item.link != item">
              <td class="text-xs-left">
                <div v-if="item">
                  <div v-if="String(item).length < 80">{{ item }}</div>
                  <div :title="item" v-else>
                    {{ String(item).substring(0, 80) + "..." }}
                  </div>
                </div>
              </td>
            </template>
          </template>
        </tr>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
  </div>
</template>
<script>

import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import MaintenanceParts from "@/components/garage/MaintenanceParts.vue";
import BeautyCarNumber from "../common/BeautyCarNumber";
import CommonMixin from "@/mixins/common";
import CarSelectorManualWindow from "@/components/common/CarSelectorManualWindow";

export default {
  name: "CarSelectorByApi",
  components: {
    CarSelectorManualWindow,
    BeautyCarNumber,
    MaintenanceParts
  },
  mixins: [CommonMixin],
  props: {
    visibilityStatus:Boolean,
    isMileageVisible:Boolean,
  },
  data: () => ({
    isVisiblecarSelectorManual: false,
    maintenancePartsForm: false,
    saveCarWindow: false,
    chooseByVin: false,
    carEditForm: false,
    id: null,
    customerEditFormTab: 0,
    showAddForm: true,
    showAddFormByVin: false,
    paramsList: [],
    selectedModelFamily: {},
    tmpCar: {
      engine: null,
      brand: null,
      catalog_code: null,
      family: null,
      model: null,
      link: null,
      name: null,
      mileage: null,
      customer_id: null,
      vin: null,
      car_number: null,
      image: null,
    },
  }),
  mounted() {
    this.onLoad();
  },
  watch: {
    selectedModificationProps(newVal){
      if(!newVal){
        this.tmpCar.link = null;
      }
    },
    visibilityStatus: function (newVal, oldVal) {
      if(newVal){
        this.onLoad()
      } else {
        this.clearForm();
      }
    },
    selectedModelFamily: function (newVal, oldVal) {
      this.ssd = '';
      if (this.showAddFormByVin || this.chooseByVin) return;
      this.tmpCar.family = newVal.family;
      this.tmpCar.model = newVal.model;
      this.paramsList = [];
      if (this.tmpCar.family && this.tmpCar.model) {
        this.$store.dispatch("garage/get", {
          method: "VehicleParamsSet",
          catalog_code: this.tmpCar.catalog_code.catalog_code,
          family: this.tmpCar.family,
          model: this.tmpCar.model,
          brand: this.tmpCar.brand,
        });
      }
    },
    tmpCar: {
      handler(to){
        //this.$emit("selected", to);
      },
      deep: true
    },
    "tmpCar.catalog_code": function (newVal, oldVal) {
      if(!newVal || this.errorToAPIAccess) return;
      if (this.showAddFormByVin || this.chooseByVin || this.carEditForm) return;
      this.selectedModelFamily = {};
      if(this.tmpCar) {
        this.tmpCar.family = null;
      }
      this.tmpCar.brand = newVal.name;
      this.$store.dispatch("garage/get", {
        method: "ModelsListGet2",
        catalog_code: newVal.catalog_code,
        brand: this.tmpCar.brand,
      });
    },
    paramsList: function (newVal, oldVal) {
      if (this.tmpCar.model) {
        let cfg = {
          method: "VehicleParamsSet",
          catalog_code: this.tmpCar.catalog_code.catalog_code,
          family: this.tmpCar.family,
          model: this.tmpCar.model,
          brand: this.tmpCar.brand,
          ssd: this.ssd,
          param: "",
        };

        if (this.paramsList.length > 0) {
          cfg.param = this.paramsList.reduce((sum, current, index) => {
            //let result = sum + current.name + ":" + current.caption + ";";
            let result = sum + current.name + ":" + current.caption;
            if(index!==this.paramsList.length-1) {
              result += ';';
            }
            return result;
          }, "");
        }

        if (this.paramForRemove) {
          let prefix = '';
          if(cfg.param.length>0){
            prefix=";";
          }
          cfg.param += prefix+this.paramForRemove.name + ":";
        }
        this.modificationsIsLoading = true;
        this.$store.dispatch("garage/get", cfg).then(() => {
          this.$store.dispatch("garage/get", {
            method: "VehicleModificationsGet",
            catalog_code: this.tmpCar.catalog_code.catalog_code,
            family: this.tmpCar.family,
            model: this.tmpCar.model,
            ssd: this.ssd,
            brand: this.tmpCar.brand,
          });
        });
      }
    },
  },
  computed: {
    ...mapFields("common", ["popularBrands"]),
    ...mapFields("garage", [
      "selectedModificationProps",
      "tmpCarId",
      "errorToAPIAccess",
      "modifications",
      "catalogs",
      "families",
      "params",
      "paramForRemove",
      "ssd",
      "modificationsIsLoading",
      "savingInProgress",
      "searchByVinInProcessing",
    ]),
    catalogsWithGroups() {

      let sorted = [];
      sorted.push(this.$t("common.popular_brands"));
      let catalogs =  JSON.parse(JSON.stringify(this.catalogs));
      catalogs.forEach((it) => {
        if (this.popularBrands.includes(it.name.toLocaleUpperCase())) {
          if (!sorted.includes(it)) sorted.push(it);
        }
      });
      sorted = sorted.sort(function (a, b) {
        if (!a.name || !b.name) return 0; //group_name
        if (a.name.toLocaleUpperCase() > b.name.toLocaleUpperCase()) {
          return 1;
        }
        if (a.name.toLocaleUpperCase() < b.name.toLocaleUpperCase()) {
          return -1;
        }
        // a должно быть равным b
        return 0;
      });
      sorted.push(this.$t("common.all_brands"));
      let all = catalogs.sort(function (a, b) {
        if (!a.name || !b.name) return 0; //group_name
        if (a.name.toLocaleUpperCase() > b.name.toLocaleUpperCase()) {
          return 1;
        }
        if (a.name.toLocaleUpperCase() < b.name.toLocaleUpperCase()) {
          return -1;
        }
        // a должно быть равным b
        return 0;
      });
      sorted = sorted.concat(all);
      return sorted;
    },
    modificationsTableHeader() {
      if (
          typeof this.modifications !== "undefined" &&
          this.modifications.length
      ) {
        let arr = Object.entries(this.modifications[0]);
        if (arr.length) {
          arr = arr
              .map((item) => {
                if (item[0] !== "link") {
                  return {
                    text: item[0],
                    value: item[0],
                    sortable: false,
                    class: "text-no-wrap",
                  };
                }
              })
              .filter((item) => {
                if (item !== undefined) return true;
              });
          arr.unshift({
            text: "",
            value: "",
            sortable: false,
            class: "text-no-wrap",
          });
          return arr;
        }
      }
      return [];
    },
    familiesList() {
      let result = [];
      for (let i in this.families) {
        for (let y in this.families[i].models) {
          result.push({
            name:
                "(" +
                this.families[i].family_name +
                ") " +
                this.families[i].models[y].model,
            family: this.families[i].family_name,
            model: this.families[i].models[y].model,
          });
        }
      }
      return result;
    },
    gettedParams() {
      let result = [];
      if (!this.params) return [];
      let names = Object.keys(this.params);
      for (let i in this.paramsList) {
        result.push({
          selected: true,
          caption: this.paramsList[i].value,
          name: this.paramsList[i].name,
          title: this.params[this.paramsList[i].name].name
        });
      }
      for (let i in names) {
        let tmp = [];
        for (let [key, value] of Object.entries(this.params[names[i]].values)) {
          tmp.push({
            name: names[i],
            caption: key,
            value: value,
            title: value,
          });
        }

        result.push({
          selected:
              this.paramsList.filter((it) => it.name === names[i]).length > 0, //false,
          name: names[i],
          caption: this.params[names[i]].name,
          title: this.params[names[i]].name,
          values: tmp,
        });
      }

      return result;
    },
  },
  methods: {
    vinFind() {
      if (!this.tmpCar.vin || this.tmpCar.vin.length < 10) return;
      this.chooseByVin = true;
      this.searchByVinInProcessing = true;
      let code = this.tmpCar.vin;
      let cfg;
      if (code.length === 17) {
        code.replace("O", "0");
        code.replace("Q", "0");
        code.replace("I", "1");
        cfg = { method: "VinFind", vin: code };
      } else {
        code.replace("O", "0");
        code.replace("Q", "0");
        code.replace("I", "1");
        cfg = { method: "FrameFind", frame: code };
      }

      this.$store.dispatch("garage/get", cfg).then((car)=>{
        if(!car) {
          this.chooseByVin = false;
        } else {
          this.tmpCar = car;
        }
      })
    },
    selectModification(link, props) {
      this.tmpCar.link = link;
      this.tmpCar.engine = link === -1 ? props.item.Engine : null;
      this.selectedModificationProps = props;
      this.tmpCar.name =
          this.tmpCar.name == "" || this.tmpCar.name == null
              ? this.tmpCar.brand + " " + this.tmpCar.family + " " + this.tmpCar.model
              : this.tmpCar.name;
    },
    selectCarManual(car){
      this.tmpCar = car;
      this.$emit("selected", this.tmpCar);
    },
    selectCar(){
      this.$emit("selected", this.tmpCar);
    },
    clearForm() {
      this.tmpCar.link = null;
      this.selectedModificationProps = null;
      this.modifications = [];
      this.families = [];
      this.selectedModelFamily = {};
      this.selectedModificationProps = null;
      for (let i in this.tmpCar) {
        this.tmpCar[i] = null;
      }
    },
    removeParamValue(param) {
      this.paramForRemove = JSON.parse(JSON.stringify(param));
      this.paramsList = this.paramsList.filter(function (obj) {
        return obj.name !== param.name;
      });
    },
    setParamValue(items) {
      if (items) this.paramsList.push(items);
    },
    onLoad() {
      this.errorToAPIAccess = false;
      this.chooseByVin = false;
      this.$store.dispatch("customer_types/get");
      this.$store.dispatch("garage/get", {
        method: "CatalogsListGet",
      });
    },
  },
};
</script>
<style lang="css" scoped>
.addToGarage {
  margin-top: -85px !important;
  position: absolute;
  right: 15px;
  margin-bottom: 0 !important;
}
</style>
